module.exports = __webpack_public_path__ + "static/img/06.c5d207d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/06.jpg
// module id = kf2S
// module chunks = 18